import {
    Calendar as CalendarIcon,
    MapPin,
    Clock,
    Users,
    CheckCircle,
    XCircle,
    Hourglass,
    UserCheck,
    History,
    Download,
    ExternalLink,
    CalendarDays,
    ChevronLeft,
    ChevronRight,
    X
} from 'lucide-react';

export enum ApplicationStatus {
    NONE = 'NONE',
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    WITHDRAWN = 'WITHDRAWN',
}

export interface Application {
    id?: string;
    userId: string;
    activityId: string;
    status: string;
    createdAt?: string;
    updatedAt?: string;
    note?: string;
}

export interface ApplicationWithApplicant {
    id: string;
    activityId: string;
    status: ApplicationStatus;
    appliedDate: Date;
    applicantName: string;
    applicantEmail: string;
    applicantAvatar: string; // image url
    note?: string;
}

export interface ApplicationWithApplicantActivity extends ApplicationWithApplicant {
    activityTitle: string;
}

export interface CreateApplicationDto {
    userId: string;
    activityId: string;
    status: string;
    note?: string;
}

export const statusConfig = {
    [ApplicationStatus.NONE]: {
        label: 'None',
        color: 'bg-gray-100 text-gray-800',
        icon: X
    },
    [ApplicationStatus.APPROVED]: {
        label: 'Approved',
        color: 'bg-green-100 text-green-800',
        icon: CheckCircle
    },
    [ApplicationStatus.PENDING]: {
        label: 'Pending',
        color: 'bg-yellow-100 text-yellow-800',
        icon: Hourglass
    },
    // waiting: {
    //     label: 'Waiting List',
    //     color: 'bg-blue-100 text-blue-800',
    //     icon: UserCheck
    // },
    [ApplicationStatus.WITHDRAWN]: {
        label: 'Withdrawn',
        color: 'bg-gray-100 text-gray-800',
        icon: X
    },
    [ApplicationStatus.REJECTED]: {
        label: 'Declined',
        color: 'bg-red-100 text-red-800',
        icon: XCircle
    },
    // completed: {
    //     label: 'Completed',
    //     color: 'bg-gray-100 text-gray-800',
    //     icon: History
    // }
};
